import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img1 from "./img/img1.png";

export const BenifitsOfWalking = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img1} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>Discover the benefits of walking</h4>
          <p className={styles.description}>

            Walking is low impact, requires minimal equipment, can be done at
            any time of day, and can be performed at your own pace.
          </p>
          <p className={styles.descriptionStrong}>

            Build a walking habit — walking daily can improve your life!
          </p>
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
